import { useContext } from 'react';

import { UnifiedDialogContext } from './UnifiedDialogContext';

export { UnifiedDialogContext } from './UnifiedDialogContext';
export type { UpdateType, UnifiedDialogContextType, UnreadState } from './UnifiedDialogContext';
export { default as UnifiedDialogContextProvider } from './UnifiedDialogContextProvider';

export const useUnifiedDialog = () => useContext(UnifiedDialogContext);
